import { Box, Button, Grid, Typography } from "@mui/material";
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import { useSuperAdminSinglePlan } from "../../context/SuperAdmin/SinglePlanContext";
import { Spinner } from "../../components/Loading/Spinner";
import SinglePlanDescription from "../../components/Table/Plan/SinglePlanDescription";
import SuscriptTable from "../../components/Table/Plan/SuscriptTable";
import EditSuscriptModal from "../../components/Table/Plan/EditSuscriptModal";
import { useNavigate } from "react-router-dom";
import DeleteSuscrModal from "../../components/Table/Users/Suscriptions/DeleteSuscrModal";

const SinglePlanPage = () => {
  const {
    isLoading,
    plan,
    isDeleting,
    toDeleteSuscr,
    handleDelete,
    assignToDeleteSuscr,
  } = useSuperAdminSinglePlan();

  const navigate = useNavigate();
  return (
    <Grid
      container
      spacing={4}
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        pt: 3,
        color: "#005559",
      }}
    >
      {/* Boton para volver */}
      <Grid item>
        <Button sx={{ color: "#336B87" }} onClick={() => navigate(-1)}>
          <ArrowBackOutlinedIcon />
          Volver
        </Button>
      </Grid>

      {isLoading ? (
        <Grid item>
          <Spinner msg="Cargando por favor espere..." />
        </Grid>
      ) : (
        <>
          {/* Título */}
          <Grid item>
            <Typography
              variant={"h4"}
              sx={{ color: "#005559", fontSize: "30px" }}
            >
              <b>Plan</b> | {plan.nombre}
            </Typography>
          </Grid>

          {/* Características del plan */}
          <Grid item>
            <SinglePlanDescription />
          </Grid>

          {/* Linea divisoria */}
          <Grid item>
            <Box
              sx={{ height: "1px", width: 1, border: "1px solid #005559" }}
            ></Box>
          </Grid>

          {/* Subtítulo */}
          <Grid item>
            <Typography variant={"h5"}>
              <b>Suscripciones relacionadas</b>
            </Typography>
          </Grid>

          {/* Sección de Tabs */}
          <Grid item>
            <SuscriptTable />
          </Grid>

          {/* Modal para editar suscripción */}
          <Grid item>
            <EditSuscriptModal />
          </Grid>

          {/* Modal para borrar suscripción de un plan */}
          <Grid item>
            <DeleteSuscrModal
              isDeleting={isDeleting}
              handleDelete={handleDelete}
              toDeleteSuscr={toDeleteSuscr}
              assignToDeleteSuscr={assignToDeleteSuscr}
              title="¿Quieres eliminar esta suscripción?"
              subtitle="Todos los usuarios anexados serán desuscritos"
            />
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default SinglePlanPage;
